import styled from 'styled-components'

export const Slide = styled.div`
  /* Instagram-style square tile: center-crop a sharp (LARGE) source. */
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  display: block;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`
